export enum ContentHouseProperties {
  Name = "name",
  Description = "description",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  Members = "members",
  Invitees = "invitees",
  Admins = "admins",
  Writers = "writers",
  Config = "config",
  Readers = "readers",
  MembershipRequests = "membershipRequests",
  State = "state",
  ContentHouseProfileImage = "contentHouseProfileImage"
}
export enum ContentHouseMetaProperties {
  MembersId = "Members-id",
  MembersVersion = "Members-version",
  InviteesId = "Invitees-id",
  InviteesVersion = "Invitees-version",
  MembershipRequestsId = "MembershipRequests-id",
  MembershipRequestsVersion = "MembershipRequests-version"
}
